import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnReset:true, addUrlParams: true});

import * as historyBack from './scripts/history-back';
historyBack.init();

import * as rangeSlider from '@elements/range-slider';
rangeSlider.init();

import * as conditionalForm from './scripts/conditional-form';
conditionalForm.init();

import * as filterDropdown from './scripts/filter-dropdown';
filterDropdown.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();